import React, {useEffect} from 'react';
import Loader from '@components/framework/loader/Loader';
import {useHistory, useParams} from 'react-router-dom';
import {
  _setDefaultGroupAfterAuth,
  _setDefaultTabAfterAuth
} from '@shared/store/actions/AuthActions';
import {BASE_ROUTE_ADMIN} from 'src/constants/route/BaseRoute';
import NavRoutes from 'src/constants/route/NavRoutes';
import {_setPriorAuthDefaultClinicIdAndFilters} from '@shared/store/actions/PriorAuthorizationsAction';
import {useTranslation} from 'react-i18next';
import {
  SYSTEM_MODULES,
  TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER
} from '@shared/constants/Mapping';
import {useDispatch} from 'react-redux';

export const PriorAuthorizationsDefaultFilter = (): JSX.Element => {
  const params = useParams<{clinic_group_id: string; clinic_id: string}>();
  const history = useHistory();
  const priorAuthorizationRoute = `/${BASE_ROUTE_ADMIN}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.ADMIN.PRIOR_AUTHORIZATIONS}`;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      dispatch(
        _setDefaultGroupAfterAuth({
          clinic_group_id: Number(params.clinic_group_id)
        })
      );
      const filterObj: any = {};
      filterObj['status'] = {
        label: t('PRIOR_AUTHORIZATION.NEEDS_CLINIC_ATTENTION'),
        value: TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.NEEDS_CLINIC_ATTENTION
      };
      dispatch(
        _setPriorAuthDefaultClinicIdAndFilters({
          clinicId: Number(params.clinic_id),
          filters: filterObj
        })
      );
      dispatch(
        _setDefaultTabAfterAuth({
          tab: SYSTEM_MODULES.PRIOR_AUTHORIZATIONS
        })
      );
      history.replace(priorAuthorizationRoute);
    } catch (e) {
      history.replace(priorAuthorizationRoute);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // @ts-ignore
  return (
    <div className="flex-centering">
      <Loader size={56} color="primary" />
    </div>
  );
};
